import React from 'react'
import _ from 'lodash'
import { MuiTable, Fab } from 'material-ui-elements'
import { PATH, LABEL } from '../constants'

const Table = ({ data, profile, history: { push } }) => {
  return (
    <div>
      <Fab onClick={() => push(`${PATH}new`)} />
      <MuiTable
        layout={MuiTable.layouts.paper}
        orderBy="isActive"
        order="desc"
        filterBy="email"
        title={LABEL}
        columns={[
          {
            name: 'email',
            label: 'Email'
          },
          {
            name: 'firstName',
            label: 'First Name'
          },
          {
            name: 'lastName',
            label: 'Last Name'
          },
          {
            name: 'phone',
            label: 'Phone'
          },
          {
            name: 'isActive',
            label: 'Status',
            style: { width: 100 },
            component: v => (v ? 'Active' : 'Inactive')
          },
          {
            name: 'role',
            label: 'Role',
            style: { width: 100 },
            component: v =>
              _.includes(v, 'admin')
                ? v === 'superadmin' ? 'SuperAdmin' : 'Admin'
                : 'User'
          }
        ]}
        data={data}
        onRowClick={i => push(`${PATH}${i}`)}
      />
    </div>
  )
}

export default Table



// WEBPACK FOOTER //
// ./src/users/components/List.js